import styled from 'styled-components';
import { ContainerBaseSkin } from '../../Field/skins/ContainerBase.skin';
export var TextAreaFieldContainerSkin = styled(ContainerBaseSkin).withConfig({
  displayName: "Containerskin__TextAreaFieldContainerSkin",
  componentId: "sc-1ekky5h-0"
})(["display:flex;flex-direction:column;position:relative;box-sizing:border-box;background-color:", ";&:hover{background-color:", ";}"], function (_ref) {
  var disabled = _ref.disabled;
  return !disabled ? '#f1f1f1' : '#f8f8f8';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return !disabled && '#eaeaea';
});